import type { SchemaDeliveryPickupPointScheduleRestriction } from '@/shared/api/openApi';

type Schedule = {
    day: number;
    timeRange: string;
};

const getScheduleIntervals = (schedule: Schedule[]) => {
    const intervals = [];

    let left = 0;
    let right = 0;

    while (right < schedule.length) {
        if (
            schedule[right].day !== (schedule[right + 1]?.day || NaN) - 1 ||
            schedule[right].timeRange !== schedule[right + 1]?.timeRange
        ) {
            intervals.push(
                left === right
                    ? { days: [schedule[left].day], timeRange: schedule[left].timeRange }
                    : { days: [schedule[left].day, schedule[right].day], timeRange: schedule[left].timeRange }
            );

            left = right + 1;
        }

        right++;
    }

    return intervals;
};

const DAYS = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];

export const formatSchedule = (schedule: SchemaDeliveryPickupPointScheduleRestriction[]): string[] => {
    const map = (schedule || [])
        .reduce<Schedule[]>((acc, { days, time_from, time_to }) => {
            if (typeof time_from === 'string' && typeof time_to === 'string') {
                const timeRange: string = `${time_from} - ${time_to}`;

                days.forEach((day) => acc.push({ day, timeRange }));
            }

            return acc;
        }, [])
        .sort((a, b) => a.day - b.day);

    const intervals = getScheduleIntervals(map);

    return intervals.map((interval) =>
        [
            // Если интервал с понедельника - 1 по воскресенье - 7, то пишем ежедневно
            interval.days[0] === 1 && interval.days[1] === 7
                ? 'Ежедневно'
                : interval.days.map((day) => DAYS[day - 1]).join(' - '),
            interval.timeRange,
        ].join(': ')
    );
};
